/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".nav-reglas[_ngcontent-%COMP%]   .card[_ngcontent-%COMP%]   .card-body[_ngcontent-%COMP%]{width:100%}.filtros-header[_ngcontent-%COMP%]{margin-right:-10px;margin-left:-10px;padding:10px}"];
export { styles as styles };
